import {
  PlusOutlined,
} from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Col,
  Form,
  Input,
  Row,
  Upload,
  Select,
  message,
} from 'antd';
import {
  fetchDieProfileList,
  resetCurrentDieProfilePage,
  resetDieProfileList,
} from '../../slices/die-profile';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import 'react-phone-input-2/lib/style.css';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';
import { Link, useNavigate } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { resetDiePressList } from '../../slices/die-press';
import { createBloster } from '../../slices/bolster';
import { fetchDiePressDropdown } from '../../slices/die-press';

const { Option } = Select;

export default function AddBolster() {
  const [form] = Form.useForm();
  const [formErrorMessage, setFormErrorMessage] = useState('');
  const [fileList, setFileList] = useState([]);
  const [searchDieProfile, setSearchDieProfile] = useState('');
  const [autoCadFileList, setAutoCadFileList] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [pressData, setPressData] = useState([]);
  const [selectedPress, setSelectedPress] = useState(null);
  const [searchPress, setSearchPress] = useState(null);
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    list: PressList,
    loading: PressLoading,
    currentpage: PressCurrentPage,
    hasMore: PressHasMore,
  } = useSelector(state => state.diePress);

  const handleChangePress = value => {
    setSearchPress(value);
    setSelectedPress(value);
  };
  const getClassName = () => {
    const selected = PressList.find(item => item.id === selectedPress);
    return selected && selected.deleted === 1
      ? 'inactive-option'
      : 'active-option';
  };

  const onScrollPress = async event => {
    const target = event.target;
    if (
      !PressLoading &&
      PressHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchDiePressDropdown({ page: PressCurrentPage, pagesize: 10 }));
    }
  };

  useEffect(() => {
    const fetchPress = async () => {
      try {
        dispatch(fetchDiePressDropdown({ page: 1, pagesize: 1000 }))
          .unwrap()
          .then(response => {
            if (response) {
              setPressData(response.results.data);
            }
          })
          .catch(error => {
            console.error('');
          });
      } catch (error) {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error);
        } else if (error instanceof Error) {
          message.error(error.message);
        } else {
          message.error('An unknown error occurred.');
        }
      }
    };

    fetchPress();
  }, []);

  useEffect(() => {
    dispatch(fetchDiePressDropdown({ page: 1, pagesize: 1000 }));
    dispatch(resetDiePressList());
  }, []);
  const [detailFileList, setDetailFileList] = useState([]);

  const handleDetailFileChange = info => {
    const newFileList = info.fileList.slice(-1);
    setDetailFileList(newFileList);
  };

  const validatePDFFileList = () => {
    if (detailFileList.length === 0) {
      return Promise.resolve();
    }
    const fileType = detailFileList[0]?.type;
    if (
      !['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'].includes(
        fileType,
      )
    ) {
      return Promise.reject(new Error('Only PDF or Image files are allowed!'));
    }
    return Promise.resolve();
  };

  const validateAutoCadFileList = () => {
    if (autoCadFileList.length === 0) {
      return Promise.resolve();
    }
    const fileExtension = autoCadFileList[0]?.name
      .split('.')
      .pop()
      ?.toLowerCase();
    if (fileExtension !== 'dwg') {
      return Promise.reject(new Error('Only DWG files are allowed!'));
    }
    return Promise.resolve();
  };
  const handleSearchDieProfile = e => {
    const value = e.target.value;
    if (value) {
      setSearchDieProfile(value);
      dispatch(resetDieProfileList());
      dispatch(fetchDieProfileList({ page: 1, pagesize: 100, search: value }));
    } else {
      setSearchDieProfile('');
      dispatch(resetDieProfileList());
      dispatch(resetCurrentDieProfilePage());
      dispatch(fetchDieProfileList({ page: 1, pagesize: 10 }));
    }
  };

  const validateFileList = () => {
    if (fileList.length === 0) {
      return Promise.reject(new Error('Please upload a file.'));
    }
    const fileType = fileList[0]?.type;
    if (
      !['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'].includes(
        fileType,
      )
    ) {
      return Promise.reject(new Error('Only PDF or Image files are allowed!'));
    }
    return Promise.resolve();
  };
  const handleFileChange = info => {
    const newFileList = info.fileList.slice(-1); // Limit to one file
    setFileList(newFileList);
    form.validateFields(['bloster_image']);
  };
  const handleAutoCadFileChange = info => {
    const newFileList = info.fileList.slice(-1); // Limit to one file
    setAutoCadFileList(newFileList);
  };
  const {
    list: dieProfileList,
    loading: dieProfileLoading,
    currentPage: dieProfileCurrentPage,
    hasMore: dieProfileHasMore,
  } = useSelector(state => state.dieProfile);

  const onScrollDieProfile = async event => {
    const target = event.target;
    if (
      !dieProfileLoading &&
      dieProfileHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(
        fetchDieProfileList({ page: dieProfileCurrentPage, pagesize: 10 }),
      );
    }
  };
  const handleFinish = values => {
    setBtnLoading(true);
    let bloster_image = fileList[0]?.originFileObj;
    let autocard = autoCadFileList[0]?.originFileObj;
    let pdf = detailFileList[0]?.originFileObj;

    dispatch(createBloster({ values, bloster_image, autocard, pdf }))
      .unwrap()
      .then(result => {
        setBtnLoading(false);
        if (result.success) {
          message.success('Bolster Created Successfully!');
          navigate('/bolster-list');
        }
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error);
        } else if (error instanceof Error) {
          message.error(error.message);
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };
  return (
    <>
      <div className="sticyaction">
        <div className="pagenamerow">
          <h2>Add Bolster</h2>
          <div className="bredcrumbwrp">
            <Link to="/bolster-list" className="back">
              <Back /> BACK
            </Link>
            <Breadcrumb
              items={[
                { title: <Link to="/dashboard">Home</Link> },
                { title: <Link to="/bolster-list">Bolsters</Link> },
                { title: 'Add Bolster' },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="formwrapper">
        <Form layout="vertical" form={form} onFinish={handleFinish}>
          <Row gutter={24}>
            <Col xs={12} sm={12} md={4} lg={4}>
              <Form.Item
                name="bloster_no"
                label="Bolster No."
                rules={[
                  { required: true, message: 'Bolster No is required!' },

                ]}
                help={formErrorMessage || undefined}
                validateStatus={formErrorMessage ? 'error' : undefined}
              >
                <Input
                  maxLength={50}
                  placeholder="Enter Bolster No."
                  onChange={e => {
                    const input = e.target;
                    const value = input.value;

                    const caretPosition = input.selectionStart;

                    const formattedValue = value
                      .toLowerCase()
                      .replace(/\b\w/g, char => char.toUpperCase());

                    form.setFieldsValue({ bloster_no: formattedValue });

                    setTimeout(() => {
                      input.setSelectionRange(caretPosition, caretPosition);
                    }, 0);
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4}>
              <Form.Item
                name="press"
                label="Press"
                rules={[{ required: true, message: 'Please select press name!' }]}
                help={formErrorMessage || undefined}
                validateStatus={formErrorMessage ? 'error' : undefined}
              >
                <AutoOpenSelect
                  placeholder="Select Press"
                  allowClear={false}
                  showSearch={true}
                  loading={PressLoading}
                  onPopupScroll={onScrollPress}
                  notFoundContent={PressLoading ? 'Loading...' : 'No options'}
                  value={searchPress}
                  onChange={handleChangePress}
                  optionFilterProp="children"
                  className={getClassName()}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {pressData.map(el => (
                    <Option key={el.id} value={el.id}
                      disabled={el.deleted === 1}>
                      {el.name}
                    </Option>
                  ))}
                </AutoOpenSelect>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col xs={12} sm={12} md={6} lg={4} xl={4}>
              <Form.Item
                name="bloster_image"
                label="Bolster Image"
                valuePropName="fileList"
                required
                getValueFromEvent={e => (Array.isArray(e) ? e : e?.fileList)}
                rules={[
                  {
                    validator: validateFileList,
                  },
                ]}
              >
                <div
                  tabIndex={0}
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      e.currentTarget.querySelector('input[type="file"]')?.click();
                    }
                    // Let browser handle Tab for natural tab order
                  }}
                  className="upload-wrapper"
                >
                  <Upload
                    beforeUpload={() => false}
                    listType="picture-card"
                    accept=".jpeg,.jpg,.png"
                    maxCount={1}
                    onChange={handleFileChange}
                    fileList={fileList}
                    showUploadList={{
                      showPreviewIcon: false,
                      showRemoveIcon: true,
                    }}
                  >
                    {fileList.length < 1 && (
                      <div>
                        <PlusOutlined />
                        <div style={{ marginTop: 8 }}>Upload</div>
                      </div>
                    )}
                  </Upload>
                </div>
                <label className="filenote">Upload JPEG, JPG or PNG file</label>
              </Form.Item>
            </Col>
            <Col xs={12} sm={12} md={6} lg={4} xl={4}>
              <Form.Item
                name="autocard"
                label="Bolster Autocad"
                rules={[
                  {
                    validator: validateAutoCadFileList,
                  },
                ]}
              >
                <div
                  tabIndex={0}
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      e.currentTarget.querySelector('input[type="file"]')?.click();
                    }
                  }}
                  className="upload-wrapper"
                >
                  <Upload
                    beforeUpload={() => false}
                    listType="picture-card"
                    accept=".dwg"
                    maxCount={1}
                    onChange={handleAutoCadFileChange}
                    fileList={autoCadFileList}
                    showUploadList={{
                      showPreviewIcon: false,
                      showRemoveIcon: true,
                    }}
                  >
                    {autoCadFileList.length < 1 && (
                      <div>
                        <PlusOutlined />
                        <div style={{ marginTop: 8 }}>Upload</div>
                      </div>
                    )}
                  </Upload>
                </div>
                <label className="filenote">Upload DWG file</label>
              </Form.Item>
            </Col>
            <Col xs={12} sm={12} md={6} lg={4} xl={4}>
              <Form.Item
                name="pdf"
                label="Bolster Pdf"
                rules={[
                  {
                    validator: validatePDFFileList,
                  },
                ]}
              >
                <div
                  tabIndex={0}
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      e.currentTarget.querySelector('input[type="file"]')?.click();
                    }
                  }}
                  className="upload-wrapper"
                >
                  <Upload
                    beforeUpload={() => false}
                    listType="picture-card"
                    accept=".pdf"
                    maxCount={1}
                    onChange={handleDetailFileChange}
                    fileList={detailFileList}
                    showUploadList={{
                      showPreviewIcon: false,
                      showRemoveIcon: true,
                    }}
                  >
                    {detailFileList.length < 1 && (
                      <div>
                        <PlusOutlined />
                        <div style={{ marginTop: 8 }}>Upload</div>
                      </div>
                    )}
                  </Upload>
                </div>
                <label className="filenote">Upload PDF file</label>
              </Form.Item>
            </Col>
          </Row>

          <div className="flex justify-end">
            <Button type="primary" htmlType="submit" icon={<PlusOutlined />}>
              Add Bloster
            </Button>
          </div>
        </Form>
      </div>
      <style>
        {`
          .upload-wrapper:focus {
            outline: 2px solid #1890ff;
            border-radius: 4px;
          }
        `}
      </style>
    </>
  );
}
